'use client';

interface ErrorPageProps {
  title: string;
  description: string;
  ctaText?: string;
  ctaAction?: () => void;
}

export function ErrorPage({
  title,
  description,
  ctaText,
  ctaAction,
}: ErrorPageProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center">
      <h1 className="text-2xl font-semibold text-foreground">{title}</h1>
      <p className="max-w-sm text-base text-muted-foreground">{description}</p>
      {ctaText && ctaAction && (
        <button
          onClick={ctaAction}
          className="mt-2 rounded-md bg-primary px-5 py-2 text-sm font-medium text-primary-foreground hover:opacity-90"
        >
          {ctaText}
        </button>
      )}
    </div>
  );
}
